import { eventStore, syncQueue } from '../../offline/indexedDBService'
import { v4 as uuidv4 } from 'uuid'
import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

	// Función genérica para registro y edición de eventos
const handleEventAction = async ({type, formData, dispatch,	isEdit = false,	id = null,	payloadBuilder = () => ({})	}) => {
	const tempId = id || uuidv4()
	const payload = payloadBuilder(formData)

	const eventPayload = {type, ...(['animals', 'lots', 'zoneTo', 'lotTo'].reduce((acc, key) => {
		if (formData[key]) acc[key] = formData[key]
			return acc
		}, {})), payload
	}

	if (!navigator.onLine) {
		await eventStore.setItem(tempId, eventPayload)
		await syncQueue.setItem(tempId, {
			type: `EVENT_${type.toUpperCase()}_${isEdit ? 'EDIT' : 'ADD'}_OFFLINE`,
			payload: isEdit ? { id: tempId, ...eventPayload } : eventPayload
		})

		dispatch({
			type: isEdit ? 'EVENT_EDIT_SUCCESS' : 'EVENT_ADD_SUCCESS',
			payload: {
				event: { ...eventPayload, _id: tempId, id: tempId, offline: true },
				message: 'success'
			}
		})
		return
	}

	try {
		const request = isEdit
		? Axios.put(`/api/event/${tempId}`, eventPayload, { headers: { auth: localStorage.getItem('jwt') } })
		: Axios.post(`/api/event/register`, eventPayload, { headers: { auth: localStorage.getItem('jwt') } })

		const { data, status } = await request

		if (status === 200) {
			dispatch({
				type: isEdit ? 'EVENT_EDIT_SUCCESS' : 'EVENT_ADD_SUCCESS',
				payload: {
				event: data.event,
				animal: data.animal,
				message: 'success'
				}
			})
		} else if (status === 260) {
			dispatch({ type: 'EVENT_WRONG_SUCCESS', payload: { message: 'needMoreData' } })
		} else {
			dispatch({ type: 'EVENT_NOT_LOADING' })
		}
	} catch (error) {
		dispatch({ type: 'EVENT_NOT_LOADING' })
	}
}

export const getEventById = (id) => async (dispatch) => {
	try {
		const response = await Axios.get(`/api/event/get/${id}`)
		dispatch({
			type: 'EVENT_LOAD_CURRENT',
			payload: response.data
		})
	} catch (error) {
		console.error('Error al obtener evento por ID:', error)
		dispatch({
			type: 'EVENT_LOAD_ERROR',
			payload: error?.response?.data?.message || 'Error desconocido'
		})
	}
}

export const getEvents = (page, limit, search) => async (dispatch) => {
	dispatch({ type: 'EVENT_LOADING' })
	try {
		const { data, status } = await Axios.post('/api/event/getall/', { page, limit, search }, {
			headers: { auth: localStorage.getItem('jwt') }
		})
		if (status === 200) {
			dispatch({
				type: 'EVENT_GETALL_SUCCESS',
				payload: data
			})
		} else {
			dispatch({ type: 'EVENT_NOT_LOADING' })
		}
	} catch (error) {
		dispatch({ type: 'EVENT_NOT_LOADING' })
	}
}

// Generador de acciones
const buildEventActions = (type, payloadBuilder) => ({
add: (formData) => async (dispatch) =>
	handleEventAction({ type, formData, dispatch, payloadBuilder }),
edit: (id, formData) => async (dispatch) =>
	handleEventAction({ type, formData, dispatch, isEdit: true, id, payloadBuilder })
})

// Acciones por tipo
export const { add: addEventAlta, edit: editEventAlta } = buildEventActions('birth', d => d)
export const { add: addEventAcquisition, edit: editEventAcquisition } = buildEventActions('acquisition', d => d)
export const { add: addEventBaja, edit: editEventBaja } = buildEventActions('death', d => ({
	cause: d.cause, causeConfirmed: d.causeConfirmed, destination: d.destination, price: d.price, weight: d.weight
}))
export const { add: addEventReview, edit: editEventReview } = buildEventActions('review', d => ({
	method: d.method,
	result: d.result,
	review: d.result === 'dudosa' ? d.review : null,
	treatment: d.result === 'tratamiento' ? d.treatment : null
}))
export const { add: addEventReviewMark, edit: editEventReviewMark } = buildEventActions('reviewMark', () => ({}))
export const { add: addEventStatus, edit: editEventStatus } = buildEventActions('status', d => ({ review: d.review }))
export const { add: addEventHeat, edit: editEventHeat } = buildEventActions('heat', d => ({ review: d.review, detectionDate: d.detectionDate }))
export const { add: addEventAbort, edit: editEventAbort } = buildEventActions('abort', d => ({
	cause: d.cause, causeConfirmed: d.causeConfirmed, review: d.review, detectionDate: d.detectionDate
}))
export const { add: addEventWeaning, edit: editEventWeaning } = buildEventActions('weaning', d => ({ weights: d.weights }))
export const { add: addEventWeight, edit: editEventWeight } = buildEventActions('weight', d => ({ weights: d.weights, weightDate: d.weightDate }))
export const { add: addEventInsemination, edit: editEventInsemination } = buildEventActions('insemination', d => ({ semental: d.semental }))
export const { add: addEventSemental, edit: editEventSemental } = buildEventActions('semental', d => ({
	entryDate: d.entryDate, exitDate: d.exitDate, semental: d.semental
}))
export const { add: addEventMovement, edit: editEventMovement } = buildEventActions('movement', d => ({
	zoneTo: d.zoneTo, lotTo: d.lotTo
}))
export const { add: addEventBirthProcess, edit: editEventBirthProcess } = buildEventActions('birthProcess', d => {
	const [tipo, nacidos] = d.birthType.split('_')
	return {tipo, nacidos, reviewMother: d.reviewMother, calfDead: d.calfDead, review: d.review	}
})